var _defs, _g, _path, _path2, _path3, _polygon, _polygon2, _path4, _g2, _polygon3, _path5, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeRoomLengthRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 325.23 198.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#ea8b77;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:#515353;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1436.96,
    y1: 15.62,
    x2: 1470.96,
    y2: 15.62,
    gradientTransform: "matrix(-1, 0, 0, 1, 1474.99, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db7860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed7159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1163.13,
    y1: 94.49,
    x2: 1461.58,
    y2: 94.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -5214.95,
    y1: -2606,
    x2: -5180.95,
    y2: -2606,
    gradientTransform: "matrix(1, 0, 0, -1, 5503.19, -2433.2)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "28.67 11.04 28.82 23.17 38.1 17.53 37.95 5.39 28.67 11.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "38.03 5.39 4.03 5.74 4.14 25.84 16.16 18.59 26 12.65 38.03 5.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "4.14 25.84 4.1 37.97 13.56 32.33 13.41 20.2 4.14 25.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "28.64 11.04 13.41 20.2 296.62 177.95 311.86 168.79 28.64 11.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.41 20.2 13.56 32.33 296.09 190.09 296.62 177.95 13.41 20.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "288.24 183.03 288.24 195.45 322.39 194.82 322.24 182.68 288.24 183.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "288.24 183.03 322.24 182.68 322.13 162.58 310.1 169.83 300.26 175.77 288.24 183.03"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M124,42l2.93,8.12v.15l-3-1.74-2.55-7.22L119.08,40v5.75l-2.81-1.62,0-15.7,5.07,2.93a10.73,10.73,0,0,1,3.73,3.4,7.56,7.56,0,0,1,1.3,4.26,3.59,3.59,0,0,1-.61,2.33A2.05,2.05,0,0,1,124,42Zm-.95-3c.38-.2.58-.65.58-1.38a4.12,4.12,0,0,0-.54-2.06A4.46,4.46,0,0,0,121.36,34L119.1,32.7v4.71l2.27,1.32a1.89,1.89,0,0,0,1.65.33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M135.09,39.31,140.16,58l-3-1.73-.94-3.78L131.3,49.6l-1,2.69-3-1.72,5.13-12.76Zm-3,8.11,3.42,2-1.7-6.86-1.72,4.89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M151.65,48.87l0,10.34c0,1.72-.47,2.8-1.41,3.26s-2.22.22-3.83-.71a10.65,10.65,0,0,1-3.8-3.65,9.16,9.16,0,0,1-1.42-4.82l0-10.46L144,44.46l0,10.36a5,5,0,0,0,.64,2.61,4.77,4.77,0,0,0,1.78,1.73c1.58.92,2.38.42,2.41-1.47l0-10.45Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "168.33 58.5 168.28 74.19 165.46 72.56 165.47 68.27 165.78 61.03 162.06 70.6 160.13 69.48 156.48 55.68 156.74 63.23 156.73 67.52 153.92 65.9 153.96 50.21 157.64 52.33 161.12 65.73 164.63 56.37 168.33 58.5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "173.6 61.55 173.57 74.64 179.54 78.09 179.53 80.69 170.74 75.61 170.79 59.92 173.6 61.55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M183.42,65.82a2.2,2.2,0,0,1-.37-1.18.81.81,0,0,1,.37-.78,1,1,0,0,1,.93.14,2.62,2.62,0,0,1,.94,1,2.28,2.28,0,0,1,.35,1.17.79.79,0,0,1-.36.76,1,1,0,0,1-.93-.14A2.59,2.59,0,0,1,183.42,65.82Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M187.91,69.8,193,88.44l-3-1.72L189,82.94l-4.93-2.85-1,2.69-3-1.73,5.12-12.75Zm-3,8.11,3.41,2L186.59,73l-1.71,4.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M188.91,69.39a2.57,2.57,0,0,1-.94-.94,2.41,2.41,0,0,1-.35-1.18.79.79,0,0,1,.37-.76,1,1,0,0,1,.93.13,2.64,2.64,0,0,1,.92.93,2.31,2.31,0,0,1,.38,1.2.8.8,0,0,1-.36.76A1,1,0,0,1,188.91,69.39Z"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "205.39 79.9 205.35 95.59 202.54 93.97 197.09 80.48 197.06 90.81 194.25 89.18 194.29 73.49 197.1 75.11 202.56 88.63 202.59 78.28 205.39 79.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M213.24,84.22A10.81,10.81,0,0,1,217,87.73a10.63,10.63,0,0,1,1.62,4.82L215.91,91a5.87,5.87,0,0,0-.83-2.45,5.09,5.09,0,0,0-1.76-1.65c-1-.55-1.69-.56-2.2,0a5,5,0,0,0-.76,3.26v1a9.64,9.64,0,0,0,.8,4.19,5.77,5.77,0,0,0,2.39,2.65c1,.61,1.8.78,2.26.53V95.76l-2.56-1.47V91.9L218.64,95l0,6.26a2.7,2.7,0,0,1-2.16.38,9.31,9.31,0,0,1-3.07-1.2,11.06,11.06,0,0,1-3.11-2.69A12.4,12.4,0,0,1,208.22,94a13.78,13.78,0,0,1-.73-4.41V88.52a8.22,8.22,0,0,1,.7-3.68,2.57,2.57,0,0,1,2-1.47A5,5,0,0,1,213.24,84.22Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "230.07 94.15 230.06 96.77 223.74 93.12 223.73 96.86 229.13 99.98 229.13 102.48 223.72 99.37 223.71 103.59 230.05 107.25 230.04 109.85 220.9 104.57 220.94 88.88 230.07 94.15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeRoomLengthRed);
export default __webpack_public_path__ + "static/media/de-room-length-red.6980003c025cd1ef52a8b4906777de57.svg";
export { ForwardRef as ReactComponent };